export default "__VITE_ASSET__be9684bc__"